import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

const Loader = ({
    show
}: any) => {
    const classes = useStyles();
    return (
               <div>
                        <Backdrop className={classes.backdrop} open={show}>
                                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default Loader;
